Apt.fn.extend('maps', {}, {
	/**
	 * Add instance source
	 *
	 * @param {String} id
	 * @param {Object} config
	 */
	addSource(id, config) {
		const scope = this;
		const instance = scope.instance;

		if (instance.sources[id]) {
			return;
		}

		scope.map.addSource(id, config);

		instance.sources[id] = config;
	},

	/**
	 * Remove instance source
	 *
	 * @param {String} [id]
	 */
	removeSource(id) {
		const scope = this;
		const instance = scope.instance;

		if (id) {
			if (instance.sources[id]) {
				scope.map.removeSource(id);

				delete instance.sources[id];
			}

			return;
		}

		Object.keys(instance.sources).forEach(id => {
			scope.map.removeSource(id);
		});

		instance.sources = [];
	}
});